module.exports = __webpack_public_path__ + "img/logo.391e8b41.png";